<template>
  <div>
      <div class="craft">
          <div class="part-one">
              <div class="base-title">
                  <!-- <div class="part-one-content"></div> -->
              </div>
          </div>
        <div style="position: relative; top: -3.7rem">
          <div class="desc-box">
            <img src="../assets/imgs/125/desc-title.png" alt="">
            <div>为深入贯彻落实习近平总书记关于新时代人才工作的新理念新战略新举措，坚持人才优先发展理念，紧扣健康事业发展需求，大力外引内培高水平卫生专业技术人才，全力打造卫生专业人才发展平台，提高我区健康服务水平</div>
          </div>
          <div class="part-three-extra">
              <img
                  src="../assets/imgs/125/part-1-title.png"
                  class="part-two-title-img"
              />
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （一）政策内容
              </div>
              <div class="main-content" style="margin-top: 0rem">
                  <div class="part-four-items">
                    对从区外引进的顶尖人才、领军人才、拔尖人才、优秀人才、基层骨干人才，可分别享受引进奖励100万元、80万元、20-40万元、10-20万元、10万元和人才奖励18万元、12万元、10-12万元、3-8万元、3万元，分5年平均发放。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （二）申报条件
              </div>
              <div class="main-content" style="margin-top: 0.6rem">
                  <div class="part-four-title">顶尖人才</div>
                  <div class="part-four-items">
                    在三级甲等医疗机构工作的国家级科研课题的负责人、国家级学术和技术带头人、“国医大师”、 国家级重点学科（专科、实验室）建设项目负责人，且具有研究生以上学历学位及相应正高级技术职称人员。
                  </div>
              </div>
              <div class="main-content" style="margin-top: 0.6rem">
                  <div class="part-four-title">领军人才</div>
                  <div class="part-four-items">
                    在三级甲等医疗机构工作的省部级及以上科研课题负责人，省级及以上学术和技术带头人、省级及以上名（中）医、省级及以上重点学科建设项目负责人，且具有医学类本科学历学位及正高级专业技术职称人员。
                  </div>
              </div>
              <div class="main-content" style="margin-top: 0.6rem">
                  <div class="part-four-title">拔尖人才</div>
                  <div class="part-four-items">
                    在三级甲等医疗机构工作的地市级及以上名（中）医或省拔尖中青年医师，课题负责人，重点学科负责人，业务科室主任、副主任或专业组长，急需紧缺专业卫生人才等，具有医学类本科及以上学历和高级专业技术职称人员。
                  </div>
              </div>
              <div class="main-content" style="margin-top: 0.6rem">
                  <div class="part-four-title">优秀人才</div>
                  <div class="part-four-items">
                    具有医学类博士研究生学历及相应学位；取得住院医师规培证的硕士研究生；“双一流”高校的公共卫生和预防医学类硕士研究生；取得住院医师规培证的“双一流”高校的本科生；取得住院医师规培证的儿科学等急需紧缺专业的临床医学本科生。
                  </div>
              </div>
              <div class="main-content" style="margin-top: 0.6rem">
                  <div class="part-four-title">基层骨干人才</div>
                  <div class="part-four-items">
                    取得住院医师规培证、执业医师资格证的医学类本科生，且具有相应学历学位或者具有相应学历及中级及以上专业技术职称人员。
                  </div>
              </div>
          </div>
          <div class="part-three-extra" style="background-color: #E8EEFF;">
              <img
                  src="../assets/imgs/125/part-2-title.png"
                  class="part-two-title-img"
              />
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （一）科研创新激励
              </div>
              <div class="main-content"  style="margin-top: 0.2rem">
                  <div class="part-four-items">
                    在新津工作的卫生技术人员，完成国家级、省级、市级科研课题项目，分别给予项目组20万、15万、10万元的科研专项奖励。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （二）名医培养激励
              </div>
              <div class="main-content" style="margin-top: 0.2rem" >
                  <div class="part-four-items">
                    在新津工作首次获得名（中）医、学术和技术带头人的个人，按国家级、省级、市级分别给予30万元、10万元、5万元的专项奖励。设立“名医（名院）工作室”的单位，分别按国家级、省级、市级给予每年20万元、15万元、10万元专项奖励。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （三）能力提升培养
              </div>
              <div class="main-content" style="margin-top: 0.2rem" >
                  <div class="part-four-items">
                    在新津工作首次取得正高级、副高级卫生专业技术任职资格的个人，分别给予12万元、6万元的人才奖励；取得住院医师规培证的研究生（具有相应学位）给予6万元的人才奖励。
                  </div>
              </div>
          </div>
          <div class="part-three-extra" style="background-color: #E8EEFF;">
              <img
                  src="../assets/imgs/125/part-3-title.png"
                  class="part-two-title-img"
              />
              <div class="main-content"  style="margin-top: 0.6rem">
                  <div class="part-four-title">一. 人才引进方式</div>
                  <div class="part-four-items">
                    由区委编办、区人社局、区卫健局组成人才引进工作小组，采取引进高层次卫生人才的方式招聘。
                  </div>
              </div>
              <div class="main-content" style="margin-top: 0.6rem" >
                  <div class="part-four-title">二. 奖励申报流程</div>
                  <div class="part-four-items">
                    引进培育的津英卫生人才享受有关激励政策的申报工作每年开展一次，由区卫健局牵头组织申报和审核，报区人才工作领导小组办公室按程序审定后落实激励政策。
                  </div>
              </div>
          </div>
          <div class="contact">
              <img
                  class="top"
                  src="./../assets/imgs/125/part-4-title.png"
                  alt=""
              />
              <div class="content">
                  <div class="number">
                      <span class="label">政策咨询电话：</span>
                      <div>
                          <a href="tel:028-61888121">028-82517285</a>
                      </div>
                  </div>
                  <div class="unit">
                      <span class="label">责任单位：</span>
                      新津区卫健局
                  </div>
              </div>
          </div>

          <!-- <div class="bottom-info" style="margin-top: 0.25rem">
              责任单位：成都市人力资源和社会保障局专业技术人员服务管理处
          </div>
          <div class="bottom-info" style="margin-top:0.15rem">
              咨询电话： <a href="tel:028-61888245">028-61888245</a>、<a href="tel:028-61888121">028-61888121</a>
          </div> -->
          <!-- <bottom
                  phone="028-61888245"
                  phone2="028-61888121"
                  unit="成都市人力资源和社会保障局专业技术人员服务管理处"
              ></bottom> -->
        </div>
      </div>
  </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
// import call from "../components/call.vue";

export default {
  name: "",
  data() {
      return {

      };
  },
  components: {
      // bottom,
      // call,
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
  background: #0839b7;
  overflow: hidden;
  padding: 0.24rem 0.12rem;
  padding-bottom: 1.65rem;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  .desc-box {
    width: 6.85rem;
      background: #fff;
      border-radius: 0.28rem;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 1.2rem;
      position: relative;
      color: #4E4E4E;
      font-size: 0.26rem;
      img {
        width: 6.85rem;
        height: 2.12rem;
        margin-top: -0.6rem;
      }
      div {
        padding: 0.36rem;
        line-height: 1.7;
        text-align: left;
      }
  }

  .part-title {
      font-size: 0.34rem;
      //font-family:: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #333333;
      position: relative;

      &::before {
          position: absolute;
          content: "";
          width: 0.28rem;
          height: 0.28rem;
          border-radius: 50%;
          background: none;
          border: 0.06rem solid #ff6d60;
          box-sizing: border-box;
          top: 0.08rem;
          left: -0.2rem;
      }
  }

  .part-text {
      font-size: 0.26rem;
      //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
  }

  .part-one {
      width: 7.5rem;
      min-height: 7.2rem;
      box-sizing: border-box;
      padding-bottom: 0.3rem;
      margin: 0 auto;

      .base-title {
          width: 7.26rem;
          min-height: 5.84rem;
          background: url(../assets/imgs/125/base-title.png);
          background-size: 100% 100%;
          position: relative;

          .part-one-content {
              width: 6.85rem;
              padding-bottom: 0.2rem;
              background: #ffffff;
              border-radius: 10px;
              position: absolute;
              top: 4.02rem;
              left: 0.22rem;
              padding-left: 0.36rem;
              padding-right: 0.37rem;
              box-sizing: border-box;
              padding-bottom: 0.35rem;

              .part-one-title-img {
                  position: absolute;
                  top: -0.32rem;
                  left: -0.18rem;
                  width: 7.03rem;
                  height: 1.37rem;
              }

              .part-one-title {
                  margin-top: 0.98rem;
                  text-align: left;
                  margin-left: 0.34rem;
              }

              .part-one-text {
                  margin-top: 0.16rem;
              }
          }
      }
  }

  .part-two-title-img {
      width: 7.03rem;
      height: 1.37rem;
      top: 0;
      left: -0.2rem;
      position: absolute;
  }

  .part-two {
      margin-left: 0.02rem;
      width: 6.85rem;
      margin-top: 0.22rem;
      background: #e8eeff;
      border-radius: 10px;
      box-sizing: border-box;
      display: inline-block;
      position: relative;

      .part-two-content {
          margin-top: 1.2rem;
          width: 100%;
          padding: 0.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          font-size: 0.26rem;
          //font-family:: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;
          text-align: left;
      }
  }

  .part-three {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 0.28rem;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 0.22rem;
      border: 0.00001px solid transparent;
      position: relative;
      padding: 1.44rem 0.25rem 0 0.25rem;
      padding-bottom: 0.35rem;

      .part-four-title {
          text-align: left;
          margin-left: 0.35rem;

          &::before {
              position: absolute;
              content: "";
              width: 0.28rem;
              height: 0.28rem;
              border-radius: 50%;
              background: none;
              border: 0.06rem solid #ff6d60;
              box-sizing: border-box;
              top: 0.08rem;
              left: -0.38rem;
          }
      }

      .main-content {
          margin-top: 0.1rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.5rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;
          padding-bottom: 0.2rem;

          .part-four-items {
              box-sizing: border-box;
              position: relative;
              margin-bottom: 0.15rem;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
          }
      }
  }

  .part-three-extra {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 0.15rem;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 0.22rem;
      border: 0.00001px solid transparent;
      position: relative;
      padding: 1.44rem 0.25rem 0 0.25rem;
      padding-bottom: 0.35rem;
      .circle-title {
        font-weight: bold;
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #333;
            margin-bottom: 0.5rem;
            margin-top: 0.2rem;

            .circle {
              width: 0.22rem;
              height: 0.22rem;
              border: 0.06rem solid #FF6D60;
              border-radius: 50%;
              margin-right: 0.05rem;
            }
      }

      .main-content {
          margin-top: 0.8rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.5rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;
          padding-bottom: 0.2rem;
          position: relative;
          // margin-bottom: 0.8rem;

          .part-four-title {
              text-align: left;
              position: absolute;
              top: 0;
              left: 50%;
              width:2.98rem;
              font-size: 0.32rem;
              background-color: #739bfeff;
              color: #fff;
              border-radius: 20px;
              text-align:center;
              padding: 0.18rem 0.2rem;
              transform: translate(-50%, -50%);
              white-space: nowrap;
          }

          .part-four-items {
              box-sizing: border-box;
              position: relative;
              margin-bottom: 0.15rem;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
              & > p {
                display: flex;
                align-items: center;
                font-size: 0.26rem;
                color: #4E4E4E;
                font-weight: bold;
                margin-top: 0.3rem;
                img {
                  width: 0.39rem;
                  height: 0.39rem;
                  margin-right: 0.14rem;
                }
              }
          }
      }
  }

  .part-four {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 10px;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      display: inline-block;
      position: relative;
      padding: 1.2rem 0.25rem 0 0.25rem;

      .part-four-title {
          text-align: left;
          margin-left: 0.35rem;

          &::before {
              position: absolute;
              content: "";
              width: 0.28rem;
              height: 0.28rem;
              border-radius: 50%;
              background: none;
              border: 0.06rem solid #ff6d60;
              box-sizing: border-box;
              top: 0.08rem;
              left: -0.38rem;
          }
      }

      .main-content {
          margin-top: 0.34rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.8rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;

          .part-four-items {
              box-sizing: border-box;
              border-left: 0.02rem dashed #739bfe;
              margin-bottom: 0.6rem;
              padding-left: 0.33rem;
              padding-top: 0.2rem;
              position: relative;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
              padding-bottom: 0.25rem;

              .title-bg {
                  position: absolute;
                  width: 3.31rem;
                  height: 0.6rem;
                  top: -0.6rem;
                  left: -0.25rem;
                  display: inline-flex;
                  align-items: center;
                  font-size: 0.34rem;
                  //font-family:: PingFang SC-Bold, PingFang SC;
                  font-weight: bold;
                  color: #3d5aa3;
                  padding-left: 0.58rem;
                  background: url(../assets/imgs/craft/part4-1.png);
                  background-size: 100% 100%;
                  white-space: nowrap;
              }

              .title-bg2 {
                  background: url(../assets/imgs/craft/part4-2.png);
                  background-size: 100% 100%;
              }

              .title-bg3 {
                  background: url(../assets/imgs/craft/part4-3.png);
                  background-size: 100% 100%;
              }

              .title-bg4 {
                  background: url(../assets/imgs/craft/part4-4.png);
                  background-size: 100% 100%;
              }

              .title-bg5 {
                  background: url(../assets/imgs/craft/part4-5.png);
                  background-size: 100% 100%;
              }

              .title-bg6 {
                  background: url(../assets/imgs/craft/part4-6.png);
                  background-size: 100% 100%;
              }

              .inside-title {
                  font-weight: 800;
              }

              .part-four-content1 {
                  margin-bottom: 0.2rem;

                  p {
                      margin: 0.01rem;
                  }
              }
          }
      }
  }

  .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #E8EEFF;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;

        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.2rem;
          position: relative;
          text-align: left;
          line-height: 0.44rem;

          color: #4E4E4E;
          font-size: 0.26rem;
          font-weight: normal;

          .title {
            font-weight: bold;
            position: absolute;
            top: -0.6rem;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .circle {
              width: 0.22rem;
              height: 0.22rem;
              border: 0.06rem solid #FF6D60;
              border-radius: 50%;
            }
          }

        }
      }
    }

}
</style>
